function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M.103 58.365c.587-2.316 1.414-4.51 3.074-6.309 2.18-2.364 4.837-3.746 8.062-3.981.504-.037 1.013-.029 1.519-.029 31.501-.001 63.002.013 94.503-.018 4.187-.004 7.555 1.496 10.176 4.757 4.382 5.452 2.656 14.114-3.468 17.523-2.033 1.132-4.159 1.661-6.474 1.661-31.657-.013-63.314-.05-94.97.029-5.903.014-11.319-4.192-12.25-10.065-.017-.104-.113-.196-.172-.293v-3.275M.103 10.409c.615-2.259 1.4-4.426 3.024-6.205C5.358 1.76 8.094.382 11.396.138c.349-.026.701-.021 1.052-.021 31.695-.001 63.39-.005 95.086.002 5.835.002 10.572 3.604 11.994 9.067 1.866 7.169-3.488 14.45-10.905 14.828-.428.022-.857.041-1.286.041-31.539.002-63.078-.006-94.618.014-3.125.002-5.907-.813-8.31-2.849C2.251 19.39.897 17.095.322 14.33c-.046-.221-.145-.431-.219-.646v-3.275M.103 106.32c.566-2.325 1.393-4.517 3.047-6.322 2.111-2.304 4.679-3.701 7.813-3.984a22.294 22.294 0 0 1 1.986-.066c31.376-.002 62.752.014 94.129-.022 4.265-.004 7.711 1.464 10.391 4.805 4.296 5.358 2.67 14.038-3.36 17.352-1.407.773-2.996 1.212-4.501 1.804h-99.21c-.172-.073-.338-.177-.517-.214-2.856-.577-5.183-2.008-7.06-4.234-1.443-1.711-2.131-3.748-2.718-5.845v-3.275z"
}));

var SvgHamburgerMenu = function SvgHamburgerMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 121 121",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHamburgerMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hamburger_menu.726589a1.svg";
export { ForwardRef as ReactComponent };